import { ca } from '@cian/analytics';

export function trackShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'show',
  });
}
